import {
  base_colorAction,
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  padding: ${spacing(5)} ${spacing(6)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};

  .card-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 ${spacing(6)};
    align-items: flex-start;
  }

  .card-right-cluster {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  .card-identity {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(3)};
    min-width: 0;
  }

  .issuer-img {
    width: 73px;
    height: auto;
    flex-shrink: 0;
  }

  .card-identity-text {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    color: ${text_colorTextPrimary};
    ${font_md}

    .font-bold {
      font-family: ${font_family_weight_medium};
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      overflow-wrap: anywhere;
    }
  }

  .card-meta {
    display: flex;
    flex-direction: row;
    gap: ${spacing(8)};
    flex-shrink: 0;
  }

  .meta-cell {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    color: ${text_colorTextPrimary};
    ${font_md}
  }

  .meta-label {
    color: ${text_colorTextSecondary};
  }

  .card-type-spacer {
    padding-top: ${spacing(3)};
  }

  .card-edit-link {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(1)};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${base_colorAction};
    font-family: ${font_family_weight_medium};
    ${font_md}
    flex-shrink: 0;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  .address-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(2)} ${spacing(6)};
    color: ${text_colorTextPrimary};
    ${font_md}
  }

  .address-column {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
  }
`
